export const profileData = [
   {
    name: "Ganga",
    type: "Primary customer"
   },
   {
    name: "Jamuna",
    type: ""
   }
]